module.exports = __webpack_public_path__ + "img/blacklist-white.svg";